'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logClientErrorWithLoggingService = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var logClientErrorWithLoggingService = exports.logClientErrorWithLoggingService = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(error, stack, code, auth) {
    var response, errorStack, userDeviceId, customError;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (config) {
              _context.next = 5;
              break;
            }

            _context.next = 3;
            return _axios2.default.get('/config', { headers: { 'Content-type': 'application/json' } });

          case 3:
            response = _context.sent;

            config = response.data;

          case 5:

            if (!error.stack && !stack) {
              errorStack = {};

              Error.captureStackTrace(errorStack, logClientErrorWithLoggingService);
              stack = errorStack.stack;
            }

            userDeviceId = (0, _Cookie.readAndSaveDeviceId)(config.envPrefix, auth && auth.realm ? auth.realm : null);
            customError = {
              error: (0, _extends3.default)({
                service: 'universal login'
              }, userDeviceId && { deviceId: userDeviceId }, auth && auth.userInfo && auth.userInfo.loginId && { loginIdentityId: auth.userInfo.loginId }, {
                message: error.message || error,
                stack: error.stack || stack,
                code: code
              })
            };
            _context.prev = 8;

            console.error(customError);
            _context.next = 12;
            return _axios2.default.post(config.errorLogUrl + '/log/universal-login/' + code, customError, {
              headers: {
                'Content-type': 'application/json',
                apiKey: config.loggerApiKey
              }
            });

          case 12:
            _context.next = 17;
            break;

          case 14:
            _context.prev = 14;
            _context.t0 = _context['catch'](8);

            console.log('logging error: ', _context.t0);

          case 17:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this, [[8, 14]]);
  }));

  return function logClientErrorWithLoggingService(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();

exports.createLoginClientError = createLoginClientError;

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _Router = require('./Router');

var _Error = require('./Error');

var _Cookie = require('./Cookie');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var config = void 0;

function createLoginClientError(errorString, stack, pushState, auth) {
  (0, _Error.logError)(errorString);
  logClientErrorWithLoggingService(errorString, stack, 'universal-loginError', auth);
  pushState((0, _Router.getErrorRetryPath)());
}


//////////////////
// WEBPACK FOOTER
// ./src/helpers/ClientError.js
// module id = 55
// module chunks = 0